import { render, staticRenderFns } from "./AppWrapper.vue?vue&type=template&id=6a0b11ab"
import script from "./AppWrapper.vue?vue&type=script&lang=ts"
export * from "./AppWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports